/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import { Action } from "../models/Action.model";
import { ApiService } from "../services/Api.service";
import { Resource, SingleDocument } from "../utils/json-api";

export class AuthApi {

    constructor(private api: ApiService) {
    }

    async validateEmail(email: string): Promise<Boolean> {
        const action = { id: "auth.validateEmail", params: { email } };
        const reqDoc = new SingleDocument<Action>().setResource(new Resource(Action.TYPE, action));
        const response = await this.api.post<Action>("/auth/validate-email", reqDoc);
        const resDoc = response.asSingleDocument();
        return resDoc.getModel().result as boolean;
    }
    
    async su(surrogatedUserId: string): Promise<string> {
        const action = { id: "auth.su", params: { surrogatedUserId } };
        const reqDoc = new SingleDocument<Action>().setResource(new Resource(Action.TYPE, action));
        const response = await this.api.post<Action>("/auth/su", reqDoc);
        const resDoc = response.asSingleDocument();
        return resDoc.getModel().result.customToken as string;
    }
    
}



// WEBPACK FOOTER //
// ./src/api/Auth.api.ts